export function toYyyyMmDd(date: Date | string) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Convert API date string or Date to Date for MUI DataGrid date columns. */
export function parseDateForGrid(value: Date | string | null | undefined): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (match) {
    const d = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Date-only fields for API DTOs (OpenAPI `format: date`, e.g. `2026-05-01`). */
export function formatDateForServer(
  date: Date | string | null | undefined
): string | undefined {
  if (date == null || date === '') return undefined;
  return toYyyyMmDd(date);
}

/** Date-time fields without timezone suffix (local wall clock). */
export function dateTimeToLocalApiString(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

/** Valori data da API (axios può deserializzare in Date o lasciare stringa ISO). */
export function dateLikeToTimestamp(v?: Date | string | null): number {
  if (v == null) return 0;
  const d = v instanceof Date ? v : new Date(v);
  const ts = d.getTime();
  return Number.isNaN(ts) ? 0 : ts;
}

export function dateLikeToYear(v?: Date | string | null): number | null {
  if (v == null) return null;
  const d = v instanceof Date ? v : new Date(v);
  const ts = d.getTime();
  if (Number.isNaN(ts)) return null;
  return d.getFullYear();
}

/** Anno dalla prima data valorizzata (es. data diagnosi con fallback su ultimo aggiornamento). */
export function dateLikeToYearCoalesce(
  ...candidates: Array<Date | string | null | undefined>
): number | null {
  for (const c of candidates) {
    const y = dateLikeToYear(c);
    if (y != null) return y;
  }
  return null;
}

export function dateLikeToIsoString(v?: Date | string | null): string | undefined {
  if (v == null) return undefined;
  if (v instanceof Date) return v.toISOString();
  return typeof v === 'string' ? v : undefined;
}
